import { useEffect, useRef, useState } from "react";
import styles from "./Dropdown.module.scss";
import { DropdownItem, DropdownProps } from "./types";
import useTranslation from "../../hooks/useTranslation";
import { observer } from "mobx-react-lite";

const Dropdown = observer(
  ({
    options,
    onItemSelected,
    activeKey,
    placement = "bottom",
  }: DropdownProps) => {
    const { t } = useTranslation();
    const dropdownRef = useRef(null);
    const [activeItem, setActiveItem] = useState(
      options.find((item) => item.key === activeKey)
    );
    const [open, setOpen] = useState(false);

    useEffect(() => {
      const clickOutsideHandler = (e: MouseEvent) => {
        if (
          dropdownRef.current &&
          !(dropdownRef.current as any).contains(e.target)
        ) {
          setOpen(false);
        }
      };
      document.addEventListener("click", clickOutsideHandler);

      return () => document.removeEventListener("click", clickOutsideHandler);
    }, []);

    const onDropdownClickHandler = () => {
      setOpen(!open);
    };

    const onItemSelectedHandler = (item: DropdownItem) => {
      setActiveItem(item);
      setOpen(false);
      typeof onItemSelected === "function" && onItemSelected(item);
    };

    return (
      <div className={styles.dropdown} ref={dropdownRef}>
        <div onClick={onDropdownClickHandler}>
          {activeItem?.icon}
          <span className="label">{t(activeItem?.value || "")}</span>
        </div>
        <ul
          className={
            open ? `${styles.open} ${styles[placement]}` : styles[placement]
          }
        >
          {options.map((item, index) => (
            <li
              key={`dropdown-item-${index}`}
              onClick={() => onItemSelectedHandler(item)}
            >
              <span className="icon">{item.icon}</span>
              <span>{t(item.value)}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
);

export default Dropdown;
